module.exports = __webpack_public_path__ + "static/media/HelpAI2.97813a53.jpg";